import { render, staticRenderFns } from "./IDC.vue?vue&type=template&id=2b7a285e&scoped=true"
import script from "./IDC.vue?vue&type=script&lang=js"
export * from "./IDC.vue?vue&type=script&lang=js"
import style0 from "./IDC.vue?vue&type=style&index=0&id=2b7a285e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a285e",
  null
  
)

export default component.exports